import { Loader, Modal, defineModal } from '@libs/ui/ds'
import useMemoSelector from '@spa/redux/hooks/useMemoSelector'
import type { FC } from 'react'
import React, { useMemo } from 'react'
import { useDispatch } from 'react-redux'
import { createNote, updateNote, deleteNote } from 'snap-redux/modules/notes'
import { getNoteById } from 'snap-redux/modules/notes/selectors'
import { getWeeklyScheduleById } from 'snap-redux/modules/weeklyschedules/selectors'

import NoteFormLegacy from './NoteForm/NoteFormLegacy'

type NoteModalProps = {
  noteId?: number
  weeklyscheduleId: number
  date: 'YY-MM-DD' | string
}

/**
 * @deprecated
 */
export const noteModalLegacyDef = defineModal<NoteModalProps>({
  name: 'noteModalLegacy'
})

const NoteModalLegacy: FC = () => {
  const { close, isOpen, data } = noteModalLegacyDef.useModal()

  // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
  const formType = data.noteId ? 'edit' : 'create'

  const dispatch = useDispatch()
  const weeklyschedule = useMemoSelector(state =>
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    getWeeklyScheduleById(state, data.weeklyscheduleId)
  )

  // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
  const note = useMemoSelector(state => getNoteById(state, data.noteId))

  const isLoading = useMemoSelector(state => {
    // note are nested inside weeklyschedule schema (daily_notes)
    return (
      !weeklyschedule ||
      state.weeklyschedules.getIn(['meta', 'loading']) ||
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      (data.noteId ? !note : false)
    )
  })

  const noteStub = useMemo(() => {
    return {
      note: null,
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      date: data.date,
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      weeklyschedule_id: data.weeklyscheduleId
    }
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.date, weeklyschedule])

  if (isLoading) {
    return <Loader.Container />
  }

  const handleSubmit = (note, newNote) => {
    if (formType === 'create') {
      // @ts-ignore migration from js(x) to ts(x)
      dispatch(createNote({ ...note, ...newNote }))
    }

    if (formType === 'edit') {
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      dispatch(updateNote(data.noteId, { ...note, ...newNote }))
    }

    close()
  }

  const handleDelete = () => {
    // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
    if (data.noteId) {
      // @ts-ignore TO DO: fix (strictNullChecks errors) (https://snapshiftapp.atlassian.net/browse/COP-333)
      dispatch(deleteNote(data.noteId))
    }
    close()
  }

  return (
    <Modal variant='center' size='s' opened={isOpen} onClose={close}>
      <NoteFormLegacy
        note={formType === 'edit' ? note : noteStub}
        onSubmit={handleSubmit}
        onNoteDelete={handleDelete}
      />
    </Modal>
  )
}

/**
 * @deprecated
 */
export default noteModalLegacyDef.withModalShow(NoteModalLegacy)
